<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-app>
    <v-overlay :value="loadingDownloadData">
      <img
        width="100"
        :src="require('@/assets/img/magnifier-zoom-search.gif')"
      />
      <center>
        <img
          class="logo-cmp"
          :src="require('@/assets/img/logoINETCMP.png')"
          width="50%"
          alt="cmp inet"
        />
        <div class="text-center">กำลังเข้าสู่ระบบ</div>
      </center>
    </v-overlay>
  </v-app>
</template>

<script>
import Swal2 from 'sweetalert2/dist/sweetalert2.js'
const Toast = Swal2.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
})

export default {
  data () {
    return {
      Token: '',
      ClientId: '',
      Url: process.env.VUE_APP_LOGIN,
      Code: 'code',
      PathUrl: '',
      DialogTerm: false,
      loadingDownloadData: false
    }
  },

  mounted () {
    if ('token' in this.$route.query) {
      this.fn_getLogin()
    } else {
      this.$router.push('/Notfound')
    }
  },

  methods: {
    async fn_getLogin () {
      this.loadingDownloadData = true
      var payload = {
        ShareToken: this.$route.query.token
      }
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + 'token/login',
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false

          if (response.data.Status === 'OK') {
            this.$cookies.set('OneUsername', response.data.Message.OneUsername)
            this.$cookies.set(
              'OneAccountId',
              response.data.Message.OneAccountId
            )
            this.$cookies.set(
              'OneAccessToken',
              response.data.Message.OneAccessToken,
              '1d'
            )
            this.$cookies.set(
              'OneRefreshToken',
              response.data.Message.OneRefreshToken,
              '1d'
            )
            this.$router.push('/consent-list')
          } else {
            Toast.fire({
              icon: 'error',
              title: response.data.ErrorMessage
            })
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title:
                this.$i18n.t('alert.contactserve') +
                error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: this.$i18n.t('alert.contactserve') + error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title:
                this.$i18n.t('alert.contactserve') + error.message || error
            })
          }
        })
    }
  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@100;200;300;400&display=swap");

@media screen and (min-width: 992px) {
  html {
    overflow: hidden;
  }
}

* {
  font-family: "Kanit", sans-serif;
}

h1 {
  font-weight: 500;
  margin-bottom: 2rem;
}

@media screen and (min-width: 992px) {
  .home-layout {
    background-image: url(https://cmp.inet.co.th/static/media/bg.56680e4d.jpg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 100vh !important;
  }
}

div#app {
  overflow: hidden;
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  background: #fff;
  border-radius: 0.5rem;
}

.center-card img {
  vertical-align: middle;
}

.center-card {
  margin: 3rem;
}

.container {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.modal-content {
  align-items: center;
  border: none;
  margin: 3rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.btn-secondary,
.btn-secondary:hover,
.btn-secondary:focus {
  color: #1890ff;
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0 0 0 0.25rem rgb(130 138 145 / 0%);
}

a {
  text-decoration: none;
}

.v-application a {
  color: #154966;
  margin: 1rem 0;
}

span {
  font-weight: 600;
}

.logo-cmp {
  width: 20rem;
}

.center-card h1 {
  font-size: 1.8rem;
}

p {
  margin: 1rem;
}

button.btn.btn-secondary {
  padding: 0 0 2rem 0;
}

.theme--light.v-btn.v-btn--has-bg {
  color: #fff !important;
  font-weight: 600;
}

.lang {
  top: 15px;
  right: 30px;
  position: absolute;
  margin: 20px;
}

.lang img {
  width: 2rem;
  border-radius: 50%;
}

.fontSize {
  font-size: 14px;
  cursor: pointer;
}
</style>
